module.exports = __webpack_public_path__ + "static/img/no-data@2x.f36ee76.png";